export default "__VITE_ASSET__BQDQ6nj6__"